import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';
import { AddressListFacade } from './address-list.facade';

@Injectable({
  providedIn: 'root',
})
export class AddressListGuard {
  constructor(private addressListFacade: AddressListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.addressListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.addressListFacade);
  }
}
